import { getRefName as e } from "./get-ref-name.js";
import { compositions as t } from "./schema-composition.js";
import { shouldRenderArrayItemComposition as n } from "./should-render-array-item-composition.js";
import { unwrapForRead as r } from "./unwrap-for-read.js";
import { resolve as i } from "@scalar/workspace-store/resolve";
import { isDefined as a } from "@scalar/helpers/array/is-defined";
import { isArraySchema as o } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
//#region src/schema/helpers/get-compositions-to-render.ts
var s = (e) => e.startsWith("#/") || e.includes("/") ? e : `#/components/schemas/${e}`, c = (t, n) => {
	if (t.oneOf || t.anyOf) return null;
	let o = t.discriminator?.mapping;
	if (!o) return null;
	let c = r(n);
	if (!c?.components?.schemas) return null;
	let l = Object.values(o).filter((e) => typeof e == "string").map((t) => {
		let n = s(t), r = e(n), a = r ? i.schema(c.components?.schemas?.[r]) : void 0;
		if (a) return {
			$ref: n,
			"$ref-value": a
		};
	}).filter(a);
	return l.length === 0 ? null : {
		...i.schema(t),
		oneOf: l
	};
}, l = (e, r, s = e ? c(e, r) : null) => e ? t.map((t) => t === "oneOf" && s ? {
	composition: t,
	value: s
} : n(e, t) && o(e) && e.items ? {
	composition: t,
	value: i.schema(e.items)
} : e[t] && !(o(e) && e.items && typeof e.items == "object" && t in e.items) ? {
	composition: t,
	value: i.schema(e)
} : null).filter(a) : [];
//#endregion
export { l as getCompositionsToRender, c as inferDiscriminatorMappingComposition };

//# sourceMappingURL=get-compositions-to-render.js.map